import { render } from "./VTextarea.vue?vue&type=template&id=2607e79b"
import script from "./VTextarea.vue?vue&type=script&lang=js"
export * from "./VTextarea.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__